export const getPutFormat = (data) => {
  const { userInfo, companyInfo, preferences } = data;
  const businessAddress = companyInfo.businessAddress || {};
  return {
    user: {
      // Step1
      first_name: (userInfo.firstName || '').trim(),
      last_name: (userInfo.lastName || '').trim(),
      username: (userInfo.userName || '').trim(),
      profile_image_key: userInfo.profileImageKey,
    },
    organization: {
      // Step2
      org_types: companyInfo.businessType,
      // Step3
      company_name: (companyInfo.companyName || '').trim(),
      business_address: {
        googleplaceobejct: {
          city: businessAddress.city || ' ',
          country: businessAddress.country || ' ',
          data: businessAddress.data || null,
          formatted_address: businessAddress.formatted_address || ' ',
          location: businessAddress.location || '',
          latitude: businessAddress.latitude || 37.8200739,
          longitude: businessAddress.longitude || -122.2735453,
          map_url: businessAddress.map_url || '-',
          place_id: businessAddress.place_id || '-',
          state: businessAddress.region || businessAddress.state || ' ',
          postcode: businessAddress.postcode || businessAddress.postal_code || ' ',
          street_line_1:
            businessAddress?.street_line_1 || businessAddress?.street_address || businessAddress?.street,
        },
      },
      // Step 5
      logo_key: companyInfo.logoImageKey,
      // Step 4
      phone: (companyInfo.phoneNumber || '').trim(),
      website: (companyInfo.website || '').trim(),
      facebook: (companyInfo.facebook || '').trim(),
      instagram: (companyInfo.instagram || '').trim(),
      twitter: (companyInfo.twitter || '').trim(),
      pinterest: (companyInfo.pinterest || '').trim(),
      // Step 6
      currency: preferences.currency,
      date_format: preferences.dateFormat?.toLowerCase(),
      time_format: preferences.timeFormat,
      hear_about_us: preferences.hear_about_us,
      number_of_events: preferences.number_of_events,
    },
  };
};

export const getFormattedData = (response) => {
  const { login, organization, listing } = response;
  const profileImg = login?.profile_image?.urls?.full?.url;
  const logoImg = organization?.logos[0]?.urls?.full?.url;
  const businessAddress = organization?.business_address || {};

  return {
    userInfo: {
      // Step1
      firstName: login?.firstname,
      lastName: login?.lastname,
      userName: login?.username,
      profileImageUrl: profileImg
        ? `https://${profileImg.replace('//', '')}`
        : null,
      profileImageKey: login?.profile_image?.key || null,
    },
    companyInfo: {
      // Step2
      businessType: organization?.org_types || [],
      // Step 3
      companyName: organization?.name,
      businessAddress: {
        city: businessAddress?.city,
        country: businessAddress?.country,
        state: businessAddress?.state || businessAddress?.region || businessAddress?.administrative_area_level_1,
        postcode: businessAddress?.postcode || businessAddress?.postal_code,
        street_line_1:
          businessAddress?.street_line_1 || businessAddress?.street_address ||
          businessAddress?.street || businessAddress?.name,
      },
      orgId: organization?.id,
      // Step 5
      logoImageKey: organization?.logos[0]?.key || null,
      logoImageUrl: logoImg ? `https://${logoImg.replace('//', '')}` : null,
      // Step 4
      phoneNumber: organization?.contact?.primary_phone || '',
      website: organization?.contact?.primary_website || '',
      facebook: listing?.facebook_profile || '',
      twitter: listing?.twitter_handle || '',
      instagram: listing?.instagram_handle || '',
      pinterest: listing?.pinterest_handle || '',
    },
    preferences: {
      // Step 6
      currency: organization?.currency,
      dateFormat: organization?.date_preference,
      timeFormat: organization?.time_preference,
      hear_about_us: organization?.hear_about_us || '',
      number_of_events: organization?.number_of_events || '',
    },
  };
};
